import React, { useState, useEffect } from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEdit,
  faTimes,
  faCopy
} from "@fortawesome/free-solid-svg-icons";

import { copyToClipboard } from "../../../utils/common";
import './Trackers.scss';

const SyntaxEditor = props => {
  const [editing, setEditing] = useState(false)
  const [codeScript, setCodeScript] = useState('')

  useEffect(() => {
    setCodeScript(props.value)
  }, [props.value])

  const onChangeScript = (e) => {
    setCodeScript(e.target.value)
  }

  const onAcceptChanges = () => {
    setEditing(false)

    if (props.onChange) {
      props.onChange(codeScript)
    }
  }

  const onCancelChanges = () => {
    setEditing(false)
    setCodeScript(props.value)
  }

  return (
    <div className="syntax-highlighter-container">
      {!editing && (
        <SyntaxHighlighter language="javascript" style={a11yDark} wrapLongLines>
          {codeScript}
        </SyntaxHighlighter>
      )}
      {
        editing && (
          <InputGroup>
          <FormControl
            placeholder="Please input code"
            aria-label="Code Script"
            as="textarea"
            rows="5"
            aria-describedby="basic-addon1"
            value={codeScript}
            onChange={onChangeScript}
          />
        </InputGroup>
        )
      }
      <div className="editor-actions">
        {!editing && (
          <div className="editor-button mr-1" onClick={() => setEditing(true)}>
            <FontAwesomeIcon icon={faEdit} />
          </div>
        )}
        {!editing && (
          <div className="editor-button mr" onClick={() => copyToClipboard(codeScript, 'Script copied!')}>
            <FontAwesomeIcon icon={faCopy} />
          </div>
        )}
        {editing && (
          <div className="editor-button mr-1" onClick={onAcceptChanges}>
            <FontAwesomeIcon icon={faCheck} />
          </div>
        )}
        {editing && (
          <div className="editor-button mr" onClick={onCancelChanges}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        )}
      </div>
    </div>
  )
}

export default SyntaxEditor;
